import { render, staticRenderFns } from "./match_search_result.vue?vue&type=template&id=4a9ef51c&"
import script from "./match_search_result.vue?vue&type=script&lang=js&"
export * from "./match_search_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports